export const getProDisplayName = (
    pro?: Maybe<string>,
    region?: Maybe<ProRegionType>,
): Maybe<string> =>
    pro === 'ASCAP' && region === 'international' ? 'ASCAP Intl.' : pro ?? null;
